import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import DynamicTable from "../../DynamicTable/DynamicTable";
import deleteCredit from "../../../api/credit/delete";
import { useAuth } from "../../../contexts/AuthContext";
import { useSnackbar } from "../../../contexts/InfoContext";
import { SpinnerContext } from "../../../contexts/SpinnerContext";
import ConfirmationDialog from "../../VersatileComponents/ConfirmationDialog";
import fetchFirestoreDataWithFilter from "../../../api/credit/get";
import EditStaffCreditForm from "../editCreditForm/staffCredit";
import Search from "../../../api/utils/search";
import StaffCreditForm from "../createCreditForm/staffCredit";
import MyHeaderComponent from "../../VersatileComponents/creditHeader";
import useUserClaims from "../../../hooks/useUserClaims";
import capitalizeString from "../../../utils/capitalizeString";
import getRequiredUserData from "../../../utils/getBranchInfo";
import { ExportToExcel } from "../../../utils/ExportToExcel";

const columns = [
  { key: "employeeName", title: "Employee Name" },
  { key: "placement", title: "Placement" },
  { key: "reason", title: "Reason" },
  { key: "amount", title: "Amount" },
  {
    key: "edit",
    title: "Edit",
  },
  {
    key: "delete",
    title: "Delete",
  },
];
const NonAdmincolumns = [
  { key: "employeeName", title: "Employee Name" },
  { key: "placement", title: "Placement" },
  { key: "reason", title: "Reason" },
  { key: "amount", title: "Amount" },
];

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  // backgroundColor: "green",
};

const flexItemStyle = {
  flex: 9,
};

const flexItemStyles = {
  flex: 1,
};

const StaffCreditTable = ({ StaffCredit }) => {
  const params = useParams();
  const [data, setData] = useState([]);
  const { user } = useAuth();
  const userClaim = useUserClaims(user);
  const [lastDoc, setLastDoc] = useState(null); // To keep track of the last document
  const [searchedData, setSearchedData] = useState([]);
  const [editRow, setEditRow] = useState(null);
  const { setIsSubmitting } = useContext(SpinnerContext);
  //   const [deleteRowId, setDeleteRowId] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const { openSnackbar } = useSnackbar();
  const branchData = getRequiredUserData();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const storedData = localStorage.getItem("userData");
  let active = "";
  if (storedData) {
    const userData = JSON.parse(storedData);
    active = userData ? userData.active : "try";
  }
  const handleEdit = (row) => {
    if (branchData.active !== row.active) {
      openSnackbar("You can only edit the credit of the active sheet.", "info");
      return;
    }
    // Disable edit for rows where employeeName is "Total Credit" and reason is "Bill credit"
    if (
      row.employeeName === "Total Bill Credit" &&
      row.reason === "Bill Credit"
    ) {
      openSnackbar("This credit entry cannot be edited.", "info");
      return;
    }
    setEditRow(row);
    setIsEditDialogOpen(true);
  };

  const handleDelete = (id) => {
    // Find the row data to check if it should be disabled
    const rowToDelete = tableData.find((row) => row.id === id);
    if (
      rowToDelete &&
      rowToDelete.employeeName === "Total Bill Credit" &&
      rowToDelete.reason === "Bill Credit"
    ) {
      openSnackbar("This credit entry cannot be deleted.", "info");
      return;
    }
    openDeleteConfirmationDialog(id);
  };

  const handleDeleteConfirmed = async () => {
    setIsSubmitting(true);
    closeDeleteConfirmationDialog();
    try {
      // Attempt to delete the credit document
      const res = await deleteCredit(user, deleteItemId, "StaffCredit");

      // Check if the deletion was successful
      openSnackbar(`${res.data.message}!`, "success");
    } catch (error) {
      if (error.response && error.response.data) {
        openSnackbar(
          error.response.data.message,
          error.response.data.type ? error.response.data.type : "error"
        );
      } else {
        openSnackbar(
          "An unexpected error occurred.Please kindly check your connection.",
          "error"
        );
      }
    }

    setIsSubmitting(false);
    setDeleteItemId(null);
  };

  const openDeleteConfirmationDialog = (id) => {
    setDeleteItemId(id);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteConfirmationDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const loadInitialData = async () => {
    try {
      fetchFirestoreDataWithFilter(
        "StaffCredit",
        null,
        8,
        data,
        setData,
        "branchId",
        params.id,
        "active",
        active
      );
      // Set the last document for pagination
    } catch (error) {}
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      setLastDoc(data[data.length - 1]);
    }
  }, [data]);

  const handleSearch = async (searchText) => {
    // Perform additional actions when searching here

    if (searchText.trim() === "") {
      setSearchedData([]);
      loadInitialData();
      // Perform actions when the search input is empty
    } else {
      const searchTextNew = capitalizeString(searchText);
      Search(
        "StaffCredit",
        null,
        1000,
        searchedData,
        setSearchedData,
        "branchId",
        params.id,
        "employeeName",
        searchTextNew
      );
    }
  };

  const handleCancel = () => {
    setSearchedData([]);
    loadInitialData();
  };

  const loadMoreData = useCallback(async () => {
    try {
      if (lastDoc) {
        fetchFirestoreDataWithFilter(
          "StaffCredit",
          lastDoc,
          10,
          data,
          setData,
          "branchId",
          params.id,
          "active",
          active
        );

        if (data.length > 0) {
          setLastDoc(data[data.length - 1]);
        }
      }
    } catch (error) {}
  }, [lastDoc, data]);

  useEffect(() => {
    const handleDynamicTableScroll = (event) => {
      const scrollPosition = event.detail.scrollPosition;
    };

    window.addEventListener("dynamicTableScroll", handleDynamicTableScroll);

    return () => {
      window.removeEventListener(
        "dynamicTableScroll",
        handleDynamicTableScroll
      );
    };
  }, []);

  const formProps = {
    type: "StaffCredit",
  };

  const tableData = searchedData.length > 0 ? searchedData : data;
  return (
    <Box m="1rem 0">
      <MyHeaderComponent
        onSearch={handleSearch}
        onCancel={handleCancel}
        formComponent={StaffCreditForm}
        formProps={formProps}
      />

      <div style={containerStyle}>
        <div style={flexItemStyle}></div>
        <div style={flexItemStyles}>
          {userClaim.superAdmin || userClaim.finance || userClaim.subAdmin ? (
            <ExportToExcel
              file={"StaffCredit"}
              branchId={branchData.requiredId}
              id={""}
              endpoint={"staffC"}
              clear={false}
              name={`StaffCreditTable-Branch ${branchData.branchName}`}
            />
          ) : null}
        </div>
      </div>
      {/* {userClaim.finance ? ( */}

      {/* <Grid container spacing={3}>
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
          {StaffCredit ? (
            <ShowBudget
              label={"TotalStaffCredit"}
              value={StaffCredit ? StaffCredit : "not available"}
              marginTop={10}
            />
          ) : null}
        </Grid>
      </Grid> */}
      {/* ) : null} */}

      <DynamicTable
        data={tableData}
        columns={userClaim.admin ? columns : NonAdmincolumns}
        loadMoreData={loadMoreData}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      <ConfirmationDialog
        open={isDeleteDialogOpen}
        handleDialogClose={closeDeleteConfirmationDialog}
        handleConfirmed={handleDeleteConfirmed} // Create this function next
        message="Are you sure you want to delete this item?"
        title="Delete Confirmation"
      />
      {isEditDialogOpen && (
        <EditStaffCreditForm
          credit={editRow}
          isEditDialogOpen={isEditDialogOpen} // Pass the state
          closeEditDialog={() => setIsEditDialogOpen(false)} // Pass the close function
        />
      )}
    </Box>
  );
};

export default StaffCreditTable;
